import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  List,
  ListItem,
  ListItemText,
  Chip,
  Divider,
  useTheme,
} from '@mui/material';
import HealingIcon from '@mui/icons-material/Healing';

const Services = ({ data }) => {
  const theme = useTheme();

  return (
    <Card elevation={3} sx={{ mb: 4, backgroundColor: theme.palette.gery.white }}>
      <CardContent>
        <Typography variant="h3" color="text.primary" display="flex" alignItems="center" gutterBottom>
          <HealingIcon sx={{ mr: 1, color: theme.palette.action.purpleLight }} fontSize="small" />
          Services Offered
        </Typography>

        {Array.isArray(data) && data.length > 0 ? (
          <List dense>
            {data.map((service, index) => (
              <React.Fragment key={index}>
                <ListItem alignItems="flex-start">
                  <ListItemText
                    primary={
                      <Typography variant="smallMedium" color="text.primary">
                        {service.name} - ₹{service.fees}
                        {service.showInPublic === 'no' && (
                          <Chip
                            label="Private"
                            size="small"
                            color="warning"
                            sx={{ ml: 1 }}
                          />
                        )}
                      </Typography>
                    }
                    secondary={
                      <Typography variant="smallRegular" color="text.secondary">
                        {service.value}
                      </Typography>
                    }
                  />
                </ListItem>
                {index < data.length - 1 && <Divider />}
              </React.Fragment>
            ))}
          </List>
        ) : (
          <Typography variant="smallRegular" color="text.secondary">
            No services listed.
          </Typography>
        )}
      </CardContent>
    </Card>
  );
};

export default Services;
